import {AnalyticsService} from '../../../../shared/services/analytics/analytics.service';
import {PathUrlEnum} from '../../../../utils/analytics.utils';
import {
  StatusService,
  StatusSuccessMessageEnum,
} from '../../../../shared/services/authentication/status.service';
import {tipo_conta} from '../../../../utils/constants.utils';
import {
  ChangeDetectorRef,
  Component,
  Input,
  ViewChild,
  OnInit,
  Output,
  EventEmitter,
} from '@angular/core';
import {FormArray, FormControl, FormGroup, Validators} from '@angular/forms';
import {IProcutatorList} from '../../../../shared/interfaces/ISellerPj';
import {ErrorMessage} from '../../../../shared/models/error-message';
import {bancos} from '../../../../utils/constants.utils';
import PatternsUtils from "../../../../utils/patterns.utils";
import CpfHelper from "../../../../helpers/cpf.helper";
import {SellerPJDataPayload} from "../../../../shared/models/sellerPj.model";
import {AccountType} from "../../../../shared/enums/accountType.enum";

@Component({
  selector: 'app-seller-data-pay-pj',
  templateUrl: './seller-data-pay-pj.component.html',
  styleUrls: ['./seller-data-pay-pj.component.scss'],
})
export class SellerDataPayPjComponent implements OnInit {
  @Input() formStepDataPay: FormGroup; //apos refatorar parar de usar, esse era o formato antigo do form
  @Input() formControls: FormControl[];
  @Input() listAccount: IProcutatorList[];
  @Input() dataCompany = new SellerPJDataPayload();
  @Output() currentAccounts = new EventEmitter();

  @ViewChild('originTwoButtons') originTwoButtons: any;

  account: boolean = true;
  numero_banco = bancos;
  contas = tipo_conta;
  title: string;
  count_data: Number[] = [];
  procurator: IProcutatorList;
  initialCount = 0;
  isOpenModalRemoveAccount = false;
  messageInfoArray: string[] = [];

  accountForm: FormGroup;
  currentItemSelected: any;
  currentIndexSelected: any;

  maskCpfCnpj = CpfHelper.maskCpfCnpj;

  constructor(
    private changeDetectorRef: ChangeDetectorRef,
    private statusService: StatusService,
    private analyticsService: AnalyticsService,
  ) {
  }

  ngOnInit(): void {
    this.accountForm = new FormGroup({
      bankAccounts: new FormArray([]),
    });

    this.accountForm.valueChanges.subscribe(() => {
      this.currentAccounts.emit(this.accountForm);
    });

    this.setAccountsFromData();

    this.analyticsService.track(PathUrlEnum.PROPRIETARIO_PJ_DADOS_PAGAMENTO);
  }

  get accountArray() {
    return this.accountForm.get('bankAccounts') as FormArray;
  }

  setAccountsFromData() {
    this.accountArray.clear();
    this.count_data = [];
    this.initialCount = 0;
    if (this.dataCompany?.bankAccounts.length) {
      this.dataCompany.bankAccounts.forEach((account, idx) => {
        const group = this.buildAccountGroup(account, idx);
        this.accountArray.push(group);
        this.count_data.push(idx + 1);
        this.initialCount++;
      });
    } else {
      this.addAccount();
    }
  }

  private buildAccountGroup(data: any = {}, index: number = 0): FormGroup {
    return new FormGroup({
      id: new FormControl(index + 1),
      procurator: new FormControl(data.documentNumber || '', null),
      name: new FormControl(data.name || '', Validators.required),
      documentNumber: new FormControl({value: data.documentNumber || '', disabled: true}, Validators.required),
      bankNumber: new FormControl(data.bankNumber || '', Validators.required),
      agencyNumber: new FormControl(data.agencyNumber || '', [
        Validators.required,
        Validators.maxLength(4),
        Validators.pattern(PatternsUtils.ONLY_NUMBERS),
      ]),
      accountNumber: new FormControl(data.accountNumber || '', [
        Validators.required,
        Validators.pattern(PatternsUtils.BANK_ACCOUNT_NUMBER_LETTER),
      ]),
      accountType: new FormControl(data.accountType || '', Validators.required),
    });
  }

  addAccount() {
    //refatorar, no futuro parar de usar esse controles
    const idx = this.accountArray.length;
    const accountGroup = this.buildAccountGroup({}, idx);
    this.accountArray.push(accountGroup);
    this.initialCount++;
    this.count_data.push(this.initialCount);
  }

  getAccountData(index: number) {
    const bankAccounts = this.accountForm.get('bankAccounts') as any;
    const selectedAccount = bankAccounts.at(index).value;
    this.currentItemSelected = selectedAccount;
    this.currentIndexSelected = index;
  }

  getFilteredOptions(index: number): any[] {
    const selectedValues = this.accountArray.controls.map(
      (control) => control.get('procurator')?.value
    );
    return this.listAccount.filter(
      (option) => !selectedValues.includes(option.documentNumber) || selectedValues[index] === option.documentNumber
    );
  }

  removeAccount(index: number) {
    // Obtenha os dados da conta no índice especificado
    this.getAccountData(index);

    // Obtenha a lista de contas
    const bankAccounts = this.accountForm.get('bankAccounts') as any;

    // Remova a conta no índice especificado da lista de contas
    bankAccounts.removeAt(index);

    // Atualize o ID de todas as contas após o índice removido
    for (let i = index; i < bankAccounts.length; i++) {
      // Obtenha a conta no índice i
      const account = bankAccounts.at(i);

      // Obtenha o campo 'id' da conta
      const idField = account.get('id');

      // Atualize o valor do campo 'id'
      idField.setValue(i + 1);
    }

    //reforar, no futuro para nao depender dessas emissoes de evento
    this.count_data.splice(index, 1);
    // this.currentAccounts.emit(this.accountForm);
  }

  accountInfo(event: any, index: number) {
    if (event.value === AccountType.CONTA_POUPANCA) {
      this.messageInfoArray[index] = 'lembre de conferir se a poupança tem limite para receber';
    } else {
      this.messageInfoArray[index] = '';
    }
  }


  setIsOpenModalRemoveAccount(index: number) {
    this.getAccountData(index);
    this.isOpenModalRemoveAccount = true;
  }

  ngAfterViewChecked(): void {
    this.changeDetectorRef.detectChanges();
  }

  getErrorInvalid(label: string): string {
    return ErrorMessage.getTextInvalid(label);
  }

  getprocurator(event: any, index: number) {
    const name = this.getOptValueByCpfCnpj(event.value);

    const bankAccounts = this.accountForm.get('bankAccounts') as FormArray;
    const accountGroup = bankAccounts.at(index) as FormGroup;

    accountGroup.patchValue({
      name: name,
      documentNumber: event.value,
    });
  }

  getOptValueByCpfCnpj(documentNumber: any) {
    const matchingProcurator = this.listAccount?.find(item => item.documentNumber === documentNumber);
    return matchingProcurator?.name ?? null;
  }

  closeModal() {
    this.isOpenModalRemoveAccount = false;
  }

  modalConfirmRemove() {
    this.removeAccount(this.currentIndexSelected);
    this.statusService.showToast('success', StatusSuccessMessageEnum.EXCLUSION_ACCOUNT);
    this.isOpenModalRemoveAccount = false;
  }

  formatBankAccount(event: any, index: number) {
    let inputValue = event.target.value.replace(/-/g, '');
    
    // Remove apenas caracteres especiais, mantendo números e letras
    inputValue = inputValue.replace(/[^0-9A-Za-z]/g, '');
    
    let formattedValue = inputValue;
    
    if (inputValue.length > 1) {
      // Separa a conta (parte antes do último caractere) do dígito (último caractere)
      let conta = inputValue.slice(0, -1);
      let digito = inputValue.slice(-1).toUpperCase();
      
      // Verifica se a conta contém apenas números
      const contaTemApenasNumeros = /^[0-9]+$/.test(conta);
      
      // Verifica se a conta não excede 28 caracteres
      const contaNaoExcedeTamanho = conta.length <= 28;
      
      // Verifica se o dígito é válido (letra ou número)
      const digitoValido = /^[0-9A-Z]$/.test(digito);
      
      // Só formata se todas as validações passarem
      if (contaTemApenasNumeros && contaNaoExcedeTamanho && digitoValido && conta.length > 0) {
        formattedValue = `${conta}-${digito}`;
      } else {
        // Mantém o valor original se inválido (campo ficará inválido)
        formattedValue = event.target.value;
      }
    }

    const bankAccounts = this.accountForm.get('bankAccounts') as FormArray;
    const accountGroup = bankAccounts.at(index) as FormGroup;

    accountGroup.patchValue({
      accountNumber: formattedValue,
    });
  }

  formatAgency(event: any, index: number) {
    let agencyNumber = event.target.value.replace(/\D/g, '');
    const maxAgency = 5;

    if (agencyNumber.length >= maxAgency) {
      agencyNumber = `${agencyNumber.slice(0, -1)}-${agencyNumber.slice(-1)}`;
    }

    const bankAccounts = this.accountForm.get('bankAccounts') as FormArray;
    const accountGroup = bankAccounts.at(index) as FormGroup;
    accountGroup.patchValue({
      agencyNumber: agencyNumber,
    });
  }
}
